import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Line, Doughnut } from "react-chartjs-2";
import { patientRequest } from "../../patientplaylist/actions";
import CropFreeIcon from "@material-ui/icons/CropFree";
import styles from "./stats.scss";
import EditIcon from "@material-ui/icons/Edit";
import TextField from "@material-ui/core/TextField";
import {
  getNbVisiteRequest,
  getTop3CategoryVisitedRequest,
  resetStatsMonthlyRequest,
  getArrayVisiteYearsRequest,
} from "./actions";

class ChartJs extends React.Component {
  static propTypes = {
    admin: PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
      successful: PropTypes.bool.isRequired,
      error: PropTypes.String,
      user: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
      }),
    }).isRequired,
    nbVisite: PropTypes.objectOf(PropTypes.any).isRequired,
    getNbVisiteRequest: PropTypes.func.isRequired,
    top3Categ: PropTypes.objectOf(PropTypes.any).isRequired,
    getTop3CategoryVisitedRequest: PropTypes.func.isRequired,
    resetStatsMonthlyRequest: PropTypes.func.isRequired,
    arrayVisiteYears: PropTypes.objectOf(PropTypes.any).isRequired,
    getArrayVisiteYearsRequest: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      errorFunctionStats: false,
      top3CategLoading: false,
      top3Categ: [],
      top3CategName: [],
      getVisiteYearsLoading: false,
      visiteYears: [],
      urlCheck: "",
      months: [
        "none",
        "janvier",
        "février",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "août",
        "septembre",
        "octobre",
        "novembre",
        "décembre",
      ],
    };
  }

  componentDidMount = async () => {
    if (
      this.props.admin &&
      this.props.admin.user &&
      this.props.admin.user.specialityId &&
      this.props.admin.user.subdomain
    ) {
      console.log("specialityId ", "5f58998c5413054024d880d5");
      this.resetStatsMonthly(
        this.props.admin.user.subdomain,
        new Date().getMonth() + 1
      );
      this.getArrayVisiteYears("test.digidocteur.com");
      await this.setState({
        urlCheck: this.props.admin.user.subdomain,
      });
      console.log("urlCheck ", this.state.urlCheck);
      this.getNbVisite(this.state.urlCheck);
      this.getTop3Categories(this.props.admin.user.specialityId);
      this.waitData();
    } else {
      this.setState({
        errorFunctionStats: true,
      });
    }
  };

  getArrayVisiteYears = (subdomain) => {
    this.props.getArrayVisiteYearsRequest(subdomain);
  };

  resetStatsMonthly = (subdomain, month) => {
    this.props.resetStatsMonthlyRequest({ subdomain, month });
  };

  // Get number stats on the website client
  /*@param: subdomain => exemple : test@digidocteur.com*/
  getNbVisite = (subdomain) => {
    this.props.getNbVisiteRequest(subdomain);
  };

  //Get top 3 section in this specialityId
  /*@param: specialityId =>  string  */
  getTop3Categories = (specialityId) => {
    this.props.getTop3CategoryVisitedRequest(specialityId);
  };

  waitData() {
    setTimeout(() => {
      if (
        this.props.top3Categ.top3Categ.top3 != undefined &&
        this.props.arrayVisiteYears.arrayVisiteYears != undefined
      ) {
        this.setState({
          top3CategLoading: true,
          top3Categ: [
            this.props.top3Categ.top3Categ.top3.top1,
            this.props.top3Categ.top3Categ.top3.top2,
            this.props.top3Categ.top3Categ.top3.top3,
          ],
          top3CategName: [
            this.props.top3Categ.top3Categ.name.name1,
            this.props.top3Categ.top3Categ.name.name2,
            this.props.top3Categ.top3Categ.name.name3,
          ],
          getVisiteYearsLoading: true,
          visiteYears: this.props.arrayVisiteYears.arrayVisiteYears,
        });
      }
    }, 1000);
  }

  //This function change state url visited
  changeUrlCheck = (newUrl) => {
    this.setState({
      urlCheck: newUrl,
    });
    // Start request on the new url
    this.getNbVisite(newUrl);
  };

  render() {
    const {
      nbVisite: {
        nbVisiteRequest,
        nbVisiteSuccess,
        nbVisiteError,
        nbVisiteWebSite,
      },
      top3Categ: {
        top3CategRequest,
        top3CategSuccess,
        top3CategError,
        top3Categ,
      },
      arrayVisiteYears: {
        arrayVisiteYearsRequest,
        arrayVisiteYearsSuccess,
        arrayVisiteYearsError,
        arrayVisiteYears,
      },
    } = this.props;

    const Top3Cat = {
      datasets: [
        {
          data: this.state.top3Categ,
          backgroundColor: [
            "rgba(255, 99, 132, 0.5)",
            "rgba(54, 162, 235, 0.5)",
            "rgba(255, 206, 86, 0.5)",
            "rgba(75, 192, 192, 0.5)",
            "rgba(153, 102, 255, 0.5)",
            "rgba(255, 159, 64, 0.5)",
          ],
          borderColor: [
            "rgba(255,99,132,1)",
            "rgba(54, 162, 235, 1)",
            "rgba(255, 206, 86, 1)",
            "rgba(75, 192, 192, 1)",
            "rgba(153, 102, 255, 1)",
            "rgba(255, 159, 64, 1)",
          ],
        },
      ],

      // These labels appear in the legend and in the tooltips when hovering different arcs
      labels: [
        `${this.state.top3CategName[0]}`,
        `${this.state.top3CategName[1]}`,
        `${this.state.top3CategName[2]}`,
      ],
    };

    const VisiteAnnuel = {
      labels: [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Decembre",
      ],
      datasets: [
        {
          label: "Nombre de visite annuel",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "rgba(75,192,192,0.4)",
          borderColor: "rgba(75,192,192,1)",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "rgba(75,192,192,1)",
          pointBackgroundColor: "#fff",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "rgba(75,192,192,1)",
          pointHoverBorderColor: "rgba(220,220,220,1)",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.visiteYears,
        },
      ],
    };

    return (
      <div>
        {!this.state.errorFunctionStats && (
          <div>
            <div className={styles.title_total_dd}>
              <h1 id={styles.TitleQrcode}>
                Statistiques de visite et Top3 des catégories les plus
                visionnées <br></br>{" "}
                {this.state.months[new Date().getMonth() + 1] +
                  " " +
                  new Date().getFullYear()}
              </h1>
            </div>
            <div className={styles.container_stats}>
              <div className={styles.container_visited}>
                <h4 className={styles.card_title}>
                  Nombre de visite sur le site{" "}
                  <a
                    href={"https://" + this.state.urlCheck}
                    className={styles.linkWebsite}
                    target="_blank"
                  >
                    {this.state.urlCheck}
                  </a>
                </h4>
                <div className={styles.containerIconQrcode}>
                  <CropFreeIcon className={styles.iconQrcode} />
                </div>
                <div className={styles.containerNumberVisite}>
                  {!nbVisiteError && !nbVisiteRequest && nbVisiteSuccess && (
                    <p className={styles.NumberVisite}>{nbVisiteWebSite}</p>
                  )}
                  {!nbVisiteSuccess && !nbVisiteError && nbVisiteRequest && (
                    <p className={styles.NumberVisite}>...</p>
                  )}
                  {!nbVisiteRequest && nbVisiteError && !nbVisiteSuccess && (
                    <p>error</p>
                  )}
                  <TextField
                    label="Url"
                    id="standard-size-normal"
                    defaultValue={this.state.urlCheck}
                  />
                  <EditIcon
                    onClick={() =>
                      this.changeUrlCheck(
                        document.getElementById("standard-size-normal").value
                      )
                    }
                    className={styles.icon_edit_stats}
                  />
                </div>
              </div>
              <div className={styles.container_top3}>
                <h4 className={styles.card_title}>Top 3 des catégories</h4>
                {!top3CategRequest &&
                  top3CategSuccess &&
                  !top3CategError &&
                  top3Categ && (
                    <div>
                      {!this.state.top3CategLoading && <span>...</span>}
                      {this.state.top3CategLoading && (
                        <Doughnut
                          data={Top3Cat}
                          options={this.doughnutPieOptions}
                        />
                      )}
                    </div>
                  )}
                {top3CategRequest &&
                  !top3CategSuccess &&
                  !top3CategError &&
                  !top3Categ && <p>LOADING</p>}
                {!top3CategRequest &&
                  !top3CategSuccess &&
                  top3CategError &&
                  !top3Categ && <p>ERROR</p>}
              </div>
            </div>
            <div id={styles.container_stats_annuel}>
              <h2 className={styles.text_stats_annuel}>Visite annuel</h2>
              {!arrayVisiteYearsRequest &&
                arrayVisiteYearsSuccess &&
                !arrayVisiteYearsError &&
                arrayVisiteYears && (
                  <div>
                    {!this.state.getVisiteYearsLoading && <span>...</span>}
                    {this.state.getVisiteYearsLoading && (
                      <div id={styles.container_graph}>
                        <Line
                          id="graph-visite"
                          ref="chart"
                          data={VisiteAnnuel}
                        />
                      </div>
                    )}
                  </div>
                )}
              {arrayVisiteYearsRequest &&
                !arrayVisiteYearsSuccess &&
                !arrayVisiteYearsError &&
                !arrayVisiteYears && <p>LOADING</p>}
              {!arrayVisiteYearsRequest &&
                !arrayVisiteYearsSuccess &&
                arrayVisiteYearsError &&
                !arrayVisiteYears && <p>ERROR</p>}
            </div>
          </div>
        )}
        {this.state.errorFunctionStats && (
          <p>Erreur lors du chargement des statistiques</p>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  admin: state.admin,
  nbVisite: state.nbVisite,
  top3Categ: state.top3Categ,
  arrayVisiteYears: state.arrayVisiteYears,
});
const ConnectedGraph = connect(mapStateToProps, {
  patientRequest,
  getNbVisiteRequest,
  getTop3CategoryVisitedRequest,
  resetStatsMonthlyRequest,
  getArrayVisiteYearsRequest,
})(ChartJs);

export default ConnectedGraph;



// WEBPACK FOOTER //
// ./src/pages/admin/stats/stats.jsx